/**
 * O `?redirect=` da URL vai direto para `location.replace`. Sem checar o
 * esquema, `javascript:` e `data:` chegavam ao sink — com o `access_token` do
 * comprador no `localStorage` desta origem. Só http(s) passa; caminho relativo
 * resolve contra a origem atual. Qualquer outra coisa → `null`, e o fluxo
 * segue para o destino de sempre.
 *
 * Diferente do `safeRedirectUrl` (destino do lojista configurado no builder,
 * que exige `https` absoluto), aqui o parâmetro já é usado com caminho e
 * `http` por integrações existentes — restringir mais quebraria redirects
 * legítimos.
 */
export const safeExternalRedirect = (
	url: string | null | undefined,
	base: string = window.location.origin
): string | null => {
	if (!url || typeof url !== 'string') return null;
	try {
		const parsed = new URL(url, base);
		if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
			return null;
		}
		return parsed.toString();
	} catch {
		return null;
	}
};
